import { computed, Ref } from '@vue/composition-api';
import {
  AdgroupFormData,
  TargetingKeywordsSearchStatus,
  InterestKeywordsInfoMap,
  InterestType
} from '@tt4b/ttam-enums';

export function useOfflineAlertPropsTags(options: {
  adgroupData: Ref<AdgroupFormData>;
  interestKeywordsInfoMap: Ref<InterestKeywordsInfoMap>;
}) {
  const { adgroupData, interestKeywordsInfoMap } = options;

  return {
    tags: computed(
      () =>
        adgroupData.value?.interestKeywordsI18n
          ?.filter?.(id => {
            const status = interestKeywordsInfoMap.value[id]?.keyword_status;
            return status === TargetingKeywordsSearchStatus.OFFLINE;
          })
          ?.map(o => interestKeywordsInfoMap.value?.[o]) ?? []
    ),
  };
}

export function useLegalOfflineAlertPropsTags(options: {
  adgroupData: Ref<AdgroupFormData>;
  interestKeywordsInfoMap: Ref<InterestKeywordsInfoMap>;
}) {
  const { adgroupData, interestKeywordsInfoMap } = options;

  return {
    tags: computed(
      () =>
        adgroupData.value?.interestKeywordsI18n
          ?.filter?.(id => {
            const status = interestKeywordsInfoMap.value[id]?.keyword_status;
            return status === TargetingKeywordsSearchStatus.LEGAL_OFFLINE;
          })
          ?.map(o => interestKeywordsInfoMap.value?.[o]) ?? []
    ),
  };
}
